module.exports = __webpack_public_path__ + "img/huehuetoca.cfd1dd04.jpg";